export const SETTINGS_RISK_INDICATOR_ORDER = ['performance', 'fairness', 'robustness', 'explainability'] as const;

export type RiskIndicatorKey = (typeof SETTINGS_RISK_INDICATOR_ORDER)[number];

const DEFAULT_LIMITS = [25, 50, 75];

export const parseLimits = (rawLimits?: string): number[] => {
  if (!rawLimits) return DEFAULT_LIMITS;
  const parsed = rawLimits.split('|').map(n => parseInt(n, 10));
  return parsed.length < 3 || parsed.some(Number.isNaN) ? DEFAULT_LIMITS : parsed;
};

export const getLimitsForIndicator = (
  indicatorName: string,
  indicatorLimits?: Partial<Record<RiskIndicatorKey, string>>,
): number[] => {
  const key = indicatorName.trim().toLowerCase() as RiskIndicatorKey;
  return parseLimits(indicatorLimits?.[key]);
};

const riskIndicatorOrderMap = new Map<string, number>(
  SETTINGS_RISK_INDICATOR_ORDER.map((indicator, index) => [indicator, index]),
);

const getRiskIndicatorOrderIndex = (indicatorName: string) => {
  const normalizedName = indicatorName.trim().toLowerCase();
  return riskIndicatorOrderMap.get(normalizedName) ?? Number.MAX_SAFE_INTEGER;
};

export const compareRiskIndicatorsBySettingsOrder = (left: string, right: string) => {
  const leftIndex = getRiskIndicatorOrderIndex(left);
  const rightIndex = getRiskIndicatorOrderIndex(right);

  if (leftIndex !== rightIndex) {
    return leftIndex - rightIndex;
  }

  return left.localeCompare(right);
};
